// app/javascript/controllers/student_fields_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "status",
    "typeBlock",
    "ddCheck", "ddFields",
    "hifzCheck", "hifzFields"
  ];

  // --- ✨ ADDED: light background per instance (no changes to your existing methods) ---
  // We don't use Stimulus values so we avoid touching static props; palette can be passed as
  // data-student-fields-palette-value='["#F9FBFF","#FFF9F4",...]' on the element if you want.

  initialize() {
    // Schedule tint after Stimulus finishes connect; also hook Cocoon events (if used)
    this._reindex = () => this._applyTintAndReflow();
    // Works even if you don't use Cocoon
    document.addEventListener("cocoon:after-insert", this._reindex);
    document.addEventListener("cocoon:after-remove", this._reindex);

    // Defer so it runs after connect() without editing your connect()
    requestAnimationFrame(() => this._applyTintAndReflow());
  }

  disconnect() {
    document.removeEventListener("cocoon:after-insert", this._reindex);
    document.removeEventListener("cocoon:after-remove", this._reindex);
  }

  _applyTintAndReflow() {
    // Default very-light pastels
    const fallback = ["#F9FBFF", "#FFF9F4", "#F6FFFB", "#F9F6FF", "#F4FFFA", "#FFF7FA"];
    let palette = fallback;

    // Optional: allow override via data-student-fields-palette-value='[...]'
    const raw = this.element?.dataset?.studentFieldsPaletteValue;
    if (raw) {
      try { const p = JSON.parse(raw); if (Array.isArray(p) && p.length) palette = p; } catch (_) {}
    }

    const allCards = Array.from(document.querySelectorAll('[data-controller~="student-fields"]'));
    let index = allCards.indexOf(this.element);
    if (index === -1) index = allCards.length - 1; // fallback if just inserted
    const color = palette[index % palette.length];

    // Apply subtle, Bootstrap-friendly styling
    Object.assign(this.element.style, {
      backgroundColor: color,
      borderRadius: "0.75rem",
      padding: this.element.style.padding || "1rem",
      marginBottom: this.element.style.marginBottom || "1rem",
      boxShadow: this.element.style.boxShadow || "0 1px 0 rgba(0,0,0,0.04) inset"
    });
  }
  // --- ✨ END ADDED ---

  connect() {
    this.syncAll();
  }

  // Actions
  onStatusChange() { this.syncStatus(); }
  onDdChange()     { this.syncDd(); }
  onHifzChange()   { this.syncHifz(); }

  // Init all
  syncAll() {
    this.syncStatus();
    this.syncDd();
    this.syncHifz();
  }

  // Show/hide enrolment-dependent blocks
  syncStatus() {
    if (!this.hasStatusTarget) return;

    const want = (this.statusTarget.dataset.studentFieldsEnrolledValue || "enrolled").toLowerCase();
    const val  = (this.statusTarget.value || "").toString().toLowerCase();
    const isEnrolled = val === want;

    this.typeBlockTargets.forEach(el => el.classList.toggle("d-none", !isEnrolled));
  }

  // Direct Debit fields
  syncDd() {
    if (!(this.hasDdCheckTarget && this.hasDdFieldsTarget)) return;
    this.ddFieldsTarget.classList.toggle("d-none", !this.ddCheckTarget.checked);
  }

  // Hifz fields
  syncHifz() {
    if (!(this.hasHifzCheckTarget && this.hasHifzFieldsTarget)) return;
    this.hifzFieldsTarget.classList.toggle("d-none", !this.hifzCheckTarget.checked);
  }
}
